'use strict';

const LOG_TO_CONSOLE = false;

function log () {
  if (LOG_TO_CONSOLE && !!window.console) {
    console.log.apply(console, [].slice.call(arguments));
  }
}

const RENDER_INTERVAL = 100;
let fixedNavScrollOffset;
const $interiorNav = $('.conquer__interior-nav');
let lastRenderTime = 0;
let isPinned = false;

function initInteriorNav () {
  log('initInteriorNav');
  const wasPinned = isPinned;
  if (wasPinned) {
    // unpin temporarily for calculations
    $interiorNav.removeClass('is-pinned');
  }
  // prevent things from jumping around by making sure the container element is always the same height
  $interiorNav.parent().css('min-height', $interiorNav.parent().height());

  // store the offset for now
  fixedNavScrollOffset = $interiorNav.offset().top;
  log(`fixedNavScrollOffset set to ${fixedNavScrollOffset}`);

  // return to previous state
  if (wasPinned) {
    $interiorNav.addClass('is-pinned');
  }
}

function checkInteriorNavPosition () {
  // make sure we're not rendering more often than needed
  const now = (new Date()).getTime();
  if (now - lastRenderTime > RENDER_INTERVAL) {
    // continue rendering...
    lastRenderTime = now;

    if (!fixedNavScrollOffset) {
      initInteriorNav();
    }

    const scrollY = window.scrollY || window.pageYOffset || 0;

    if (scrollY > fixedNavScrollOffset) {
      if (!isPinned) {
        log('pinning now');
        $interiorNav.addClass('is-pinned');
        isPinned = true;
      }
    } else {
      if (isPinned) {
        log('unpinning');
        $interiorNav.removeClass('is-pinned');
        isPinned = false;
      }
    }
  }

  window.requestAnimationFrame(function () {
    checkInteriorNavPosition();
  });
}

function debounce (func, wait, immediate) {
  let timeout;
  return function () {
    const context = this; const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) { func.apply(context, args); }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) { func.apply(context, args); }
  };
}

$(window).resize(debounce(function () {
  initInteriorNav();
}, 300));

// fancy pants anchor links
$interiorNav.find('a').on('click', function (click) {
  if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
    let target = $(this.hash);
    target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top,
        easing: 'swing'
      }, 600);
      return false;
    }
  }
});

if ('requestAnimationFrame' in window) {
  window.requestAnimationFrame(checkInteriorNavPosition);
}
